import React from 'react';
import { Link } from 'react-router-dom';
import {
  ShieldCheck, Zap, Globe, BarChart3, Lock, Eye,
  ArrowRight, CheckCircle, ChevronRight
} from 'lucide-react';
import { useLang } from '../context/LanguageContext';
import translations from '../i18n/translations';
import './Home.css';

const featureIcons = [
  <ShieldCheck size={24} />,
  <Eye size={24} />,
  <Globe size={24} />,
  <Zap size={24} />,
  <BarChart3 size={24} />,
  <Lock size={24} />,
];

const trustedBy = ['FinBank', 'NeoVault', 'TrustPay', 'ClearLend', 'Orbex', 'ShieldFi'];
const badges = ['GDPR', 'SOC 2', 'ISO 27001', 'CCPA', 'AML', 'PCI DSS'];

export default function Home() {
  const { lang } = useLang();
  const t = translations[lang].home;

  return (
    <div className="home">
      {/* Hero */}
      <section className="hero">
        <div className="hero__grid" />
        <div className="hero__orb hero__orb--1" />
        <div className="hero__orb hero__orb--2" />
        <div className="container hero__content">
          <div className="hero__badge animate-fade-up">
            <span className="hero__badge-dot" />
            {t.badgeText}
          </div>
          <h1 className="hero__title animate-fade-up delay-1">
            {t.heroTitle1}<br />
            {t.heroTitle2} <span className="gradient-text">{t.heroTitle3}</span>
          </h1>
          <p className="hero__subtitle animate-fade-up delay-2">{t.heroSubtitle}</p>
          <div className="hero__actions animate-fade-up delay-3">
            <Link to="/contact" className="btn-primary">
              {t.startTrial} <ArrowRight size={16} />
            </Link>
            <Link to="/Features" className="btn-primary">
              {t.Features} <ArrowRight size={16} />
            </Link>
            <Link to="/use-cases" className="btn-outline">
              {t.exploreUseCases}
            </Link>
          </div>
        </div>

        <div className="hero__visual animate-fade-up delay-4">
          <div className="shield-card">
            <div className="shield-card__ring shield-card__ring--1" />
            <div className="shield-card__ring shield-card__ring--2" />
            <div className="shield-card__core">
              <ShieldCheck size={56} strokeWidth={1.5} />
            </div>
            <div className="shield-card__label">{t.verificationActive}</div>
            <div className="shield-card__pills">
              <span className="pill pill--green">{t.idVerified}</span>
              <span className="pill pill--blue">{t.livenessPass}</span>
              <span className="pill pill--cyan">{t.amlClear}</span>
            </div>
          </div>
        </div>
      </section>

      {/* Stats */}
      <section className="stats-bar">
        <div className="container stats-bar__inner">
          {t.stats.map((s, i) => (
            <div key={i} className="stat-item">
              <span className="stat-item__value gradient-text">{s.value}</span>
              <span className="stat-item__label">{s.label}</span>
            </div>
          ))}
        </div>
      </section>

      {/* Trusted By */}
    {/*   <section className="trusted">
        <div className="container">
          <p className="trusted__label">{t.trustedLabel}</p>
          <div className="trusted__logos">
            {trustedBy.map((name, i) => (
              <div key={i} className="trusted__logo">{name}</div>
            ))}
          </div>
        </div>
      </section> */}

      {/* Features */}
      <section className="features">
        <div className="container">
          <div className="section-header">
            <span className="section-tag">{t.capabilitiesTag}</span>
            <h2 className="section-title">
              {t.capabilitiesTitle1}<br />
              <span className="gradient-text">{t.capabilitiesTitle2}</span>
            </h2>
            <p className="section-desc">{t.capabilitiesDesc}</p>
          </div>
          <div className="features__grid">
            {t.features.map((f, i) => (
              <div key={i} className="feature-card">
                <div className="feature-card__icon">{featureIcons[i]}</div>
                <h3 className="feature-card__title">{f.title}</h3>
                <p className="feature-card__desc">{f.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Compliance */}
      <section className="compliance section">
        <div className="container compliance__inner">
          <div className="compliance__text">
            <span className="section-tag">{t.securityTag}</span>
            <h2 className="section-title">
              {t.securityTitle1}<br />
              <span className="gradient-text">{t.securityTitle2}</span>
            </h2>
            <p className="section-desc">{t.securityDesc}</p>
            <ul className="compliance__list">
              {t.benefits.map((b, i) => (
                <li key={i}>
                  <CheckCircle size={16} className="compliance__check" />
                  {b}
                </li>
              ))}
            </ul>
            <Link to="/contact" className="btn-primary" style={{ marginTop: '2rem' }}>
              {t.talkCompliance} <ArrowRight size={16} />
            </Link>
          </div>
          <div className="compliance__visual">
            <div className="compliance__badge-grid">
              {badges.map((b, i) => (
                <div key={i} className="compliance__badge">
                  <Lock size={14} />
                  {b}
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="cta-section section">
        <div className="container">
          <div className="cta-box">
            <div className="cta-box__glow" />
            <h2 className="cta-box__title">{t.ctaTitle}</h2>
            <p className="cta-box__desc">{t.ctaDesc}</p>
            <div className="cta-box__actions">
              <Link to="/contact" className="btn-primary">
                {t.startTrial} <ArrowRight size={16} />
              </Link>
               <Link to="/Features" className="btn-primary">
              {t.Features} <ArrowRight size={16} />
            </Link>
              <Link to="/use-cases" className="btn-outline">
                {t.viewUseCases} <ChevronRight size={16} />
              </Link>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
